import React from 'react';
import { Button, CheckBox, Modal } from '@roo/roo';
import Header from '../../components/HeaderWithoutMenu';
import '@roo/roo/theme/default/index.css';
import { toastFail, TimeLine } from '../../utils/utils';
import { PAGE_TYPE } from '../../utils/config';
import { signUserAgreement, getConf, ProjectTypeEnums } from '../../assets/apis/base';
import img_hb from './img-huanbao.png';
import img_qs from './img-qingshan.png';
import { Agreement } from './Agreement';

import './index.scss';

class Declare extends React.Component {
  ref = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      type: '',
      check: false,
      sciId: undefined,
      inoId: undefined,
      TimeLineConfig: {},
    };
  }

  componentDidMount() {
    getConf()
      .then((conf) => {
        const { timestamp, projectConfDto = [] } = conf || {};
        // const { sciStartTime, sciEndTime, inoStartTime, inoEndTime, earlyTime, lastTime } = TimeLine(projectConfDto);
        const TimeLineConfig = TimeLine(projectConfDto || [], timestamp);
        TimeLineConfig.timestamp = timestamp;
        // 项目 id 可能变化，但是 type 不会变化
        const confSci = (projectConfDto || []).find((t) => Number(t.type) === ProjectTypeEnums.SciType);
        const confIno = (projectConfDto || []).find((t) => Number(t.type) === ProjectTypeEnums.InoType);
        let initType = '';
        const {
          sciStartTime, sciEndTime, inoStartTime, inoEndTime,
        } = TimeLineConfig;

        if ((timestamp < inoEndTime) && (timestamp > inoStartTime)) {
          initType = 'innovate';
        }
        if ((timestamp < sciEndTime) && (timestamp > sciStartTime)) {
          initType = 'scientist';
        }
        this.setState({
          sciId: confSci?.id, inoId: confIno?.id, TimeLineConfig, type: initType,
        });
      });
  }

  onSubmit = () => {
    const {
      type, check, sciId, inoId,
    } = this.state;
    if (!type) {
      toastFail('请选择申报类型');
      return;
    }

    if (!check) {
      toastFail('请确认同意承诺书');
      return;
    }

    Modal.confirm({
      title: '确认提交？',
      status: 'question',
      children: (
        <div>
          <p>
            {
              type === 'scientist' ? '您已选择青山科技奖的申报，申报类型一旦选择将无法更改。请谨慎操作！' : '您已选择"科创中国"美团青山环保科技创新示范项目的申报，申报类型一旦选择将无法更改。请谨慎操作！'
            }
          </p>

        </div>
      ),
      onConfirm: () => {
        // 签署用户协议
        signUserAgreement({ projectConfigId: this.state.type === 'scientist' ? sciId : inoId }).finally(() => {
          localStorage.setItem(PAGE_TYPE, type);
          localStorage.setItem(this.state.type === 'scientist' ? 'signSci' : 'signIno', 'true');
          if (this.props.history) {
            this.props.history.replace({ pathname: `/apply/${type}` });
          } else {
            window.location.replace(`/apply/${type}`);
          }
        });
      },
    });
  };

  render() {
    const {
      check, type, TimeLineConfig,
    } = this.state;
    const {
      sciStartTime, sciEndTime, inoStartTime, inoEndTime, timestamp,
    } = TimeLineConfig;
    return (
      <>
        <Header plate="申报平台" />
        <div className="page-declare">
          <div className="warp declare-only-wrap">
            <h1 className="title">请选择申报类型</h1>
            <div className="award-choose-wrap">
              {
                (timestamp < sciEndTime) && (timestamp > sciStartTime) ? (
                  <div
                    className={`left ${type === 'scientist' ? 'active' : ''}`}
                    onClick={() => this.setState({ type: 'scientist', check: false })}
                    style={{ position: 'relative' }}
                  >
                    <p>青山科技奖</p>
                    <p>
                      聚焦绿色、低碳、可持续发展的公益性奖项，支持鼓励更多青年科学家投身相关基础科学和前沿技术研究，探索绿色、低碳、可持续发展的未来。奖项通过公开、公正、公平的申报和评审程序，支持资助对相关领域科技进步有关键推动作用的青年科研工作者。
                    </p>
                  </div>
                ) : null
              }
              {
                (timestamp < inoEndTime) && (timestamp > inoStartTime) ? (
                  <div
                    className={`right ${type === 'innovate' ? 'active' : ''}`}
                    onClick={() => this.setState({ type: 'innovate', check: false })}
                    style={{ position: 'relative' }}
                  >
                    <p>
                      "科创中国"
                      <p style={{ marginTop: 8 }}>美团青山环保科技创新示范项目</p>
                    </p>
                    <p style={{ marginTop: 13 }}>
                      聚焦绿色创新包装应用、绿色回收再生技术应用以及绿色供应链数字
                      {/* <br /> */}
                      化三大领域，公开征集具创新性、环保性、
                      {/* <br /> */}
                      示范性的先进技术和项目，推动一批
                      {/* <br /> */}
                      环保创新科技成果应用落地，形成
                      {/* <br /> */}
                      可复制的示范案例，切实推进
                      {/* <br /> */}
                      外卖行业绿色低碳循环发展。
                      {/* <img
                    src={img_hb}
                    alt=''
                    style={{ height: 160, width: 290, position: 'absolute', bottom: 0, right: 0 }}
                  /> */}
                    </p>
                  </div>
                ) : null
              }
            </div>
            <CheckBox
              className="check"
              checked={check}
              onChange={() => this.setState({ check: !check })}
            >
              确认同意

              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                // eslint-disable-next-line no-script-url
                href="javascript:;"
                onClick={() => {
                  if (this.ref.current) {
                    this.ref.current.open();
                  }
                }}
              >
                {this.state.type === 'scientist'
                  ? '《青山科技奖申请人承诺书》'
                  : '《科创中国-美团青山环保科技创新示范项目申报承诺书》'}
              </a>
              相关内容，申报类型一旦选择将无法更改。
            </CheckBox>
            <div className="btn">
              <Button onClick={this.onSubmit} disabled={!this.state.check}>
                确认，进入申报流程
              </Button>
            </div>
          </div>
          <Agreement
            type={this.state.type === 'scientist' ? 1 : 2}
            ref={this.ref}
            onConfirm={() => {
              this.setState({ check: true });
            }}
          />
        </div>
      </>
    );
  }
}

export default Declare;
